const FEATURE_HELP_URLS = {
  agent_bots: 'https://meu.bot/hc/agent-bots',
  agents: 'https://meu.bot/hc/agents',
  audit_logs: 'https://meu.bot/hc/audit-logs',
  campaigns: 'https://meu.bot/hc/campaigns',
  canned_responses: 'https://meu.bot/hc/canned',
  channel_email: 'https://meu.bot/hc/email',
  channel_facebook: 'https://meu.bot/hc/fb',
  custom_attributes: 'https://meu.bot/hc/custom-attributes',
  dashboard_apps: 'https://meu.bot/hc/dashboard-apps',
  help_center: 'https://meu.bot/hc/help-center',
  inboxes: 'https://meu.bot/hc/inboxes',
  integrations: 'https://meu.bot/hc/integrations',
  labels: 'https://meu.bot/hc/labels',
  macros: 'https://meu.bot/hc/macros',
  reports: 'https://meu.bot/hc/reports',
  sla: 'https://meu.bot/hc/sla',
  team_management: 'https://meu.bot/hc/teams',
  webhook: 'https://meu.bot/hc/webhooks',
  billing: 'https://meu.bot/hc/pricing',
  saml: 'https://meu.bot/hc/saml',
  captain: 'https://meu.bot/hc/captain-docs',
  captain_billing: 'https://meu.bot/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
